import { useApi } from '@backstage/core-plugin-api';
import { uptimeMonitorApiRef } from '../api/UptimeMonitorApi';
import { useAsyncFn } from 'react-use';
import { useEffect } from 'react';
import { TransactionGroupDetailRequest, TransactionGroup } from '../types';

export const useTransactionGroupDetail = (params: TransactionGroupDetailRequest | null) => {
  const api = useApi(uptimeMonitorApiRef);

  const [state, fetch] = useAsyncFn(async (): Promise<TransactionGroup | undefined> => {
    if (!params) return undefined;
    
    try {
      console.log('Fetching transaction group detail for:', params);
      const result = await api.getTransactionGroupDetail(params);
      console.log('Transaction group detail result:', result);
      return result;
    } catch (err: any) {
      console.error('Error fetching transaction group detail:', err);
      throw err;
    }
  }, [params?.host, params?.org, params?.id]);

  useEffect(() => {
    if (params) {
      fetch();
    }
  }, [params?.host, params?.org, params?.id, fetch]);

  return {
    isLoading: state.loading,
    data: state.value,
    error: state.error,
    refetch: fetch,
  };
};